import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";
import { useAuthContext } from "../context/AuthContext";

/**
 * Lista usuários do tipo ChatBot (URA) para tabela e rotas de edição.
 */
export function useChatbots() {
  const queryClient = useQueryClient();
  const { userData } = useAuthContext();

  const listQuery = useQuery(
    ["chatbots", "users"],
    async () => {
      const res = await fetchData("/users?limit=500&tipo_responsavel=chatbots", "GET");
      const data = res?.data ?? res ?? [];
      return Array.isArray(data) ? data : [];
    },
    { staleTime: 15_000, refetchOnWindowFocus: false }
  );

  const deleteMutation = useMutation(
    async (payload) => {
      const id = payload && typeof payload === "object" ? payload.id : payload;
      const resolutions = payload && typeof payload === "object" ? payload.resolutions : undefined;
      await fetchData(`/users/${id}`, "DELETE", resolutions ? { resolutions } : {});
      return id;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["chatbots"]);
      },
    }
  );

  const updateMutation = useMutation(
    async ({ userId, active }) => {
      await fetchData(`/users/${userId}`, "PUT", {
        status: active ? 1 : 0,
        id_usuario_ultima_alteracao: userData?.id ?? null,
      });
      return userId;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["chatbots"]);
      },
    }
  );

  return {
    ...listQuery,
    deleteMutation,
    updateMutation,
    refetch: listQuery.refetch,
  };
}
